import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/markup-calculator',
  component: () => import('../../routes/MarkupCalc.svelte'),
  card: {
    id: 'markup-calculator',
    title: 'Markup Calculator',
    description: 'Calculate selling price, profit, and gross margin from cost and markup percentage.',
    icon: 'price_change',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/markup-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Markup Calculator – Calculate Selling Price & Profit Margin',
    description: 'Free markup calculator to find selling price, profit, and gross margin from cost and markup percentage. Includes a markup-to-margin conversion table.',
  },
};

export default meta;